import React from 'react';
import Portal from "../../../utils/Portal";
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";

function DeleteEmployee(props) {
    const axiosPrivate = useAxiosIntercept();

    const deleteEmp = async () =>{
        try{
            let payload = {};
            payload.user_id = props.data.user_id;
            payload.user_data = {};
            payload.user_data.status = "D";

            const res = await axiosPrivate.post( process.env.REACT_APP_EDIT_USER_URL, payload);
            props.close(true);
            // if(res?.status == 200){
            //     alert("deleted");
            // }
        }
        catch(err){
            console.log(err);
        }
    }
    return (

            <Portal>
                <div id="myModal" className="popup_box open">
                    <div className="model_box">
                        <div
                            className="model_box_child deleteUserP"
                            id="deleteUserP"
                            style={{ maxWidth: 570 }}
                        >
                            <div className="ap_heading">
                                <h4>
                                    Are you sure you want to delete employee?{" "}
                                    <span className="material-symbols-rounded black close_model" onClick={()=>{props.close(false)}}>
                                        close
                                    </span>
                                </h4>
                            </div>
                            <div className="contentSection">
                                <div className="boxT1 fill">
                                    <h4 className="mb-8">
                                        <span>{props.data.firstname} {props.data.lastname}</span>
                                    </h4>
                                    <p>
                                        {props.data.designation && <span>{props.data.designation}</span>}
                                    </p>
                                </div>
                                <div className="contentSection">
                                    <div className="actionButtons mt-8">
                                        <a href="javascript:void(0);" className="btn prim btnError" onClick={()=>{deleteEmp(); props.close(true);}}>
                                            Yes, delete
                                        </a>
                                        <a href="javascript:void(0);" className="btn seco" onClick={()=>{props.close(false)}}>
                                            No, don’t delete
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>

    );
}

export default DeleteEmployee;